import script from "./RoomsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomsPage.vue?vue&type=script&setup=true&lang=js"

import "./RoomsPage.vue?vue&type=style&index=0&id=54ded87c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ded87c"]])

export default __exports__